import { useAuth } from '@/contexts/useAuth';
import { hasAccess } from '@/lib/rbac';
import type { UserRole } from '@/lib/auth';
import AccessDeniedPage from '@/pages/AccessDeniedPage';

interface RBACGuardProps {
  requiredRole: UserRole | UserRole[];
  children: React.ReactNode;
}

/**
 * Wraps protected content and renders AccessDenied when the
 * authenticated user's role is insufficient.
 *
 * Accepts a single role or an array — if an array is provided the
 * user must satisfy at least one of the listed roles.
 */
export default function RBACGuard({ requiredRole, children }: RBACGuardProps) {
  const { role: userRole } = useAuth();

  const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
  const permitted = roles.some((r) => hasAccess(userRole, r));

  if (!permitted) {
    return <AccessDeniedPage />;
  }

  return <>{children}</>;
}
